/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    itemPrices: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerItemPrices = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_ITEM_PRICES':
            var { data } = action;
            newState.itemPrices = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerItemPrices;